export default "__VITE_ASSET__fdef567f__"